import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCircleciComponent } from './simple-icons-circleci.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCircleciComponent ],
    exports:      [ SimpleIconsCircleciComponent ],
    bootstrap:    []
})
export class SimpleIconsCircleciModule {}
